export default __webpack_public_path__ + "media/images/main/calendar_h-fdbc8299423d299cfbdc1371ac271765.png";